// extracted by mini-css-extract-plugin
export default {"error":"connection_error-module__error--Sr7ua"};